<template>
  <div class="infoBox">
    <table class="info" border="1"> 
      <tr>
        <th>发起人</th>
        <td>{{ user.userName }}</td>
        <th>所属部门</th>
        <td>{{ user.deptName}}</td>
        <!-- <th>{{ pageType === 'detail'?'年底第几次调整': '年度已有几次调整'  }}</th>
        <td>{{ listCount }}</td> -->
      </tr>
      <tr>
        <th>手机号</th>
        <td>{{ user.phone }}</td>
        <th>邮箱</th>
        <td>{{ user.email }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "userTable",
  props: {
    pageType: {
      default: null
    },
    user: {
      default: () => {}
    },
    // listCount: {
    //   default: null,
    // }
    
  },
};
</script>


<style lang='scss' scoped>
.infoBox {
  .info {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #ebeef5;
    tr {
      height: 48px;
      th {
        box-sizing: border-box;
        background-color: #fafafa;
        text-align: left;
        padding:0 20px;
        width: 180px;
      }
      td {
        box-sizing: border-box;
        text-align: left;
        padding:0 20px;
        line-height: 22px;
      }
    }
  }
}
</style>
